import React from 'react';
import { Skeleton } from '@mui/material';
import { ProductTile } from '@shared-components/molecules/ProductTile';
import css from './DealTile.module.css';

function DealTileSkeleton(): JSX.Element {
  return (
    <ProductTile testId='deal-tile-skeleton' className={css['deal-tile__container']}>
      <Skeleton
        variant="rectangular"
        className={css['deal-tile__skeleton']}
      />
    </ProductTile>
  );
}

export default DealTileSkeleton;
